/**
 * Class to handle saved data in localStorage
 * Incognito modus does not support localStorage.
 * This wrapper is supportered in Incognito.
 *
 * @author Michel Heitbrink
 */
class ApplicationStorage {

	constructor() {

        this.values = [];

        if ( localStorage ) {

            Object.keys(localStorage).forEach( (key) => {

                this.values[key] = localStorage[key];

            });
        }
    }

    getItem( key ) {

        var item;

        try {
            item = localStorage.getItem(key);

            if ( item === null ){

                if ( typeof this.values[key] !== "undefined" && this.values[key] !== null ){
                    item = this.values[key];
                }
            }
        }
        catch(err) {
            item = self.values[key];
        }

        return item;
    }

    setItem( key, value ) {

        this.values[key] = value;

        try {
            localStorage.setItem(key, value);
        }
        catch(err) {}
    }

    removeItem( key ) {

        delete this.values[key];

        try {
            localStorage.removeItem(key);
        }
        catch(err) {}

    }

    hasItem( key ) {

        try {
            return ( localStorage.getItem(key) != null );
        }
        catch(err) {
            return ( this.values[key] != null );
        }

        return false;
    }

    hasItems() {

        try {
            return ( localStorage.length > 0 );
        }
        catch(err) {
            return ( this.values.length > 0 );
        }

        return false;
    }
}

export default new ApplicationStorage();

/*
---
name: Application Storage
category: JavaScript
subcategory: Helpers
tags: [javascript]
---
Class to handle saved data in localStorage. Incognito modus does not support localStorage. This wrapper is supportered in Incognito.

Example
======
```js
import ApplicationStorage from '@classes/ApplicationStorage';

ApplicationStorage.getItem(name);
ApplicationStorage.setItem(name, value);
ApplicationStorage.removeItem(name);
ApplicationStorage.hasItem(name);
ApplicationStorage.hasItems();
```
*/
